import { useLocation } from "react-router-dom";
import { isPWA, isWebView } from "../utils/helpers";
import ROUTES from "../utils/routes";

const mainGamePageRoutes = ["/", ""];

export default function useMainBackground() {
  const location = useLocation();
  const cls = ["main"];

  if (!mainGamePageRoutes.includes(location.pathname)) {
    cls.push("main__bg-1");
  }
  if ((isWebView() || isPWA()) && location.pathname === ROUTES.LANDING_PAGE) {
    cls.push("main__no-background-color");
  }
  if (isWebView() || isPWA()) {
    cls.push("main__mobile-device");
  }
  return cls.join(" ");
}
